import { makeStyles } from '@soil-capital/ui-kit/style';

export default makeStyles()(() => {
    return {
        input: { width: 250 },
    };
});
